import { useEffect, useState } from "react";
import { readEncryptedJsonResponse } from "../common/readEncryptedJsonResponse";
import { NavLink } from "react-router-dom";
import { createCookie, readCookie, to12HourFormat } from "../common/helper";

const FooterCharts = () => {
    const [markets, setMarkets] = useState([]);
    const [starlines, setStarlines] = useState([]);
    const [jackpots, setJackpots] = useState([]);

    useEffect(() => {
        // Fetch markets
        let _markets = readCookie("Star123-chart-markets");
        if (_markets) {
            _markets = JSON.parse(_markets);
            setMarkets(_markets);
        } else {
            fetchMarkets();
        }

        // Fetch starlines
        let _starlines = readCookie("Star123-starline-chart-markets");
        if (_starlines) {
            _starlines = JSON.parse(_starlines);
            setStarlines(_starlines);
        } else {
            fetchStarlines();
        }

        // Fetch jackpots
        let _jackpots = readCookie("Star123-jackpot-chart-markets");
        if (_jackpots) {
            _jackpots = JSON.parse(_jackpots);
            setJackpots(_jackpots);
        } else {
            fetchJackpots();
        }
    }, []);

    const fetchMarkets = async () => {
        const host = process.env.REACT_APP_API_HOST;
        fetch(host + '/api/market-listing', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        })
            .then((response) => readEncryptedJsonResponse(response))
            .then((data) => {
                setMarkets(data);
                createCookie('Star123-chart-markets', JSON.stringify(data), 1);
            })
            .catch((error) => console.log("Error fetching markets => ", error));
    };

    const fetchStarlines = async () => {
        const host = process.env.REACT_APP_API_HOST;
        fetch(host + '/api/starline-listing', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        })
            .then((response) => readEncryptedJsonResponse(response))
            .then((data) => {
                setStarlines(data);
                createCookie('Star123-starline-chart-markets', JSON.stringify(data), 1);
            })
            .catch((error) => console.log("Error fetching starlines => ", error));
    };

    const fetchJackpots = async () => {
        const host = process.env.REACT_APP_API_HOST;
        fetch(host + '/api/jackpot-listing', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        })
            .then((response) => readEncryptedJsonResponse(response))
            .then((data) => {
                setJackpots(data);
                createCookie('Star123-jackpot-chart-markets', JSON.stringify(data), 1);
            })
            .catch((error) => console.log("Error fetching jackpots => ", error));
    };

    return (
        <div className="footer-charts-section">
            <div className="container">
                <div className="row">
                    {/* Jodi Charts */}
                    {markets.length > 0 && (
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                            <h4 className="footer-chart-title">Jodi Charts</h4>
                            <ul className="footer-chart-list">
                                {markets.map((market, index) => (
                                    <li key={index}>
                                        <NavLink 
                                            to={`/charts/jodi/${market.name}`}
                                            className="footer-chart-link-simple"
                                        >
                                            {market.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Pana Charts */}
                    {markets.length > 0 && (
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                            <h4 className="footer-chart-title">Pana Charts</h4>
                            <ul className="footer-chart-list">
                                {markets.map((market, index) => (
                                    <li key={index}>
                                        <NavLink 
                                            to={`/charts/pana/${market.name}`}
                                            className="footer-chart-link-simple"
                                        >
                                            {market.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Starline Charts */}
                    {starlines.length > 0 && (
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                            <h4 className="footer-chart-title">Starline Charts</h4>
                            <ul className="footer-chart-list">
                                {starlines.map((starline, index) => (
                                    <li key={index}>
                                        <NavLink 
                                            to={`/chart/starline/${starline.time}`}
                                            className="footer-chart-link-simple"
                                        >
                                            {to12HourFormat(starline.time)}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Jackpot Charts */}
                    {jackpots.length > 0 && (
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                            <h4 className="footer-chart-title">Jackpot Charts</h4>
                            <ul className="footer-chart-list">
                                {jackpots.map((jackpot, index) => (
                                    <li key={index}>
                                        <NavLink 
                                            to={`/chart/jackpot/${jackpot.time}`}
                                            className="footer-chart-link-simple"
                                        >
                                            {to12HourFormat(jackpot.time)}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FooterCharts;

